import axios from "axios";
import { baseUrl } from "../store/slices/auth";
import { getLeadAttributionFields } from "./leadAttribution";

const STORAGE_KEY = "yellowhub.ad-visit-attempts.v1";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const attempted = new Set<string>();

export const notifyAdVisit = async (): Promise<void> => {
  if (typeof window === "undefined" || process.env.NODE_ENV !== "production") return;
  const params = new URL(window.location.href).searchParams;
  if (!UTM_KEYS.some((key) => params.get(key)?.trim())) return;

  const fields = getLeadAttributionFields();
  const campaign = JSON.stringify(Object.entries(fields).filter(([key]) => key.endsWith("(UTM)")));
  if (attempted.has(campaign)) return;

  try {
    const stored: unknown = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || "[]");
    if (Array.isArray(stored)) {
      stored.filter((item): item is string => typeof item === "string")
        .slice(-100).forEach((item) => attempted.add(item));
    }
  } catch {
    // Fall back to in-memory deduplication when storage is unavailable.
  }
  if (attempted.has(campaign)) return;
  attempted.add(campaign);
  try {
    // Record the attempt before sending: reloads and uncertain network results must not flood Telegram.
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(attempted).slice(-100)));
  } catch {
    // Notification delivery must not affect page rendering.
  }

  try {
    await axios.post(`${baseUrl}telegram/lead-request`, {
      title: "Перехід за рекламним посиланням (не заявка)",
      fields: {
        Відвідувач: "Анонімний — ім'я та контактні дані невідомі",
        ...fields,
      },
    }, { timeout: 10000 });
  } catch {
    // Visit notifications are best-effort, with no automatic retry or interruption of the visit.
  }
};
